import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import vw from 'styles/utils';

function CategoryThumbnail(props) {
  const { title, subtitle1, href1, subtitle2, href2 } = props;

  return (
    <Root>
      <Column>
        {
          (subtitle1 || subtitle2) ? (
            <Title showBorder>{title}</Title>
          ) : (
            <TitleHref href={href1} target='_blank' rel="noreferrer" showBorder>
              <p>{title}</p>
            </TitleHref>
          )
        }
      </Column>
      {
        (subtitle1 || subtitle2) && (
          <Column>
            {
              subtitle1 && (
                <a href={href1} target='_blank' rel="noreferrer">
                  <Button>{subtitle1}</Button>
                </a>
              )
            }
            {
              subtitle2 && (
                <a href={href2} target='_blank' rel="noreferrer">
                  <Button>{subtitle2}</Button>
                </a>
              )
            }
          </Column>
        )
      }
    </Root>
  )
}

CategoryThumbnail.propTypes = {
  title: PropTypes.string,
  subtitle1: PropTypes.string,
  href1: PropTypes.string,
  subtitle2: PropTypes.string,
  href2: PropTypes.string
}

const Root = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${require('assets/images/home/category-thumbnail.jpeg')});
`;

const Column = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
`;

const TitleHref = styled.a`
  > p {
    color: white;
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 400;
    text-align: center;
    color: #FFFFFF;
    border: ${props => props.showBorder && '1px solid #FFFFFF'};
    transition: all 0.25s ease-in-out;

    ${vw('font-size', 12, 14, 16)}
    ${vw('line-height', 24, 28, 32)}
  }

  &:hover {
    > p {
      border: ${props => props.showBorder && '1px solid #3398DC'};
      color: #3398DC;
    }
  }
`;

const Title = styled.p`
  color: white;
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;
  text-align: center;
  color: #FFFFFF;
  border: ${props => props.showBorder && '1px solid #FFFFFF'};

  ${vw('font-size', 12, 14, 16)}
  ${vw('line-height', 24, 28, 32)}
`;

const Button = styled.button`
  background: none;
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;
  text-align: center;
  color: #FFFFFF;
  border: 1px solid #FFFFFF;
  box-sizing: border-box;
  transition: all 0.25s;
  cursor: pointer;

  ${vw('font-size', 12, 14, 16)}
  ${vw('line-height', 24, 28, 32)}
  ${vw('margin-top', 4)}
  ${vw('margin-bottom', 4)}
  ${vw('width', 50, 70, 92)}

  &:hover {
    color: #3398DC;
    border: 1px solid #3398DC;
  }
`;

export default CategoryThumbnail
